import { Link } from 'react-router-dom'
import { useSettings } from '~/@mid_settings/settings'
import { LogoLightIcon } from '../icons/LogoLightIcon'
import { SocialLogoLink } from './SocialLogoLink'

function Footer() {
  const { getLandingPageLink } = useSettings()

  const data = [
    <Link
      key="1"
      target="_blank"
      rel="noopener noreferrer"
      to={getLandingPageLink('documents/ochrana_osobnych_udajov.pdf')}
      className="text-accent">
      Ochrana osobných údajov
    </Link>,
    <Link
      key="2"
      target="_blank"
      rel="noopener noreferrer"
      to={getLandingPageLink('documents/podmienky_pouzivania_portalu.pdf')}
      className="text-accent">
      Podmienky používania portálu
    </Link>,
    <Link key="3" to="mailto:info@investinslovakia.eu" className="text-accent">
      info@investinslovakia.eu
    </Link>,
    <span key="4" className="text-accent">
      +421 910 548 844
    </span>,
  ]

  return (
    <div className="border-t border-border p-10 pb-[100px] lg:pb-5 bg-foreground w-full flex flex-col gap-9">
      <div className="flex flex-row items-center justify-between">
        <LogoLightIcon />
        <div className="flex flex-row gap-[15px]">
          <SocialLogoLink brand="facebook" />
          <SocialLogoLink brand="instagram" />
          <SocialLogoLink brand="linkedin" />
        </div>
      </div>
      <div className="flex flex-col items-center">
        <div className="text-center max-w-[355px]">
          {data.map((text, index) => (
            <span key={index} className="text-sm font-semibold leading-4">
              {!!index && <span className="text-primary-foreground"> | </span>}
              {text}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export { Footer }
